// @flow strict

import * as React from 'react';
import { LoadingIndicator } from '@ansarada/ace-react';
import styles from './styles.scss';
import UpflowyLayout from '../../../components/UpflowyLayout';

type Props = {|
  show: boolean,
|};

const LoadingSubHeading = () => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <LoadingIndicator dark />
    <p style={{ marginLeft: '10px' }}>It will be ready in seconds</p>
  </div>
);

const LoadingScreen = ({ show }: Props) => {
  return (
    <UpflowyLayout
      className={styles.upflowyLayout}
      style={{ opacity: show ? '1' : '0' }}
      heading="Hang tight! We're baking a fresh data room just for you."
      subHeading={<LoadingSubHeading />}
      illustrationSrc=""
    >
      <div style={{ minHeight: '220px' }} />
    </UpflowyLayout>
  );
};

export default LoadingScreen;
